import { gql } from '@apollo/client';

const OrderSuccessTrackingQuery = gql`
  query OrderSuccessTrackingQuery($orderNumber: ID) {
    user {
      id
      language
      hash
      customer {
        id
        lastRegistrationDate
      }
      order(id: $orderNumber) {
        id
        currency
        onHold
        storeNumber
        discountAmount
        previousOrderDate
        couponCode
        subTotalInclTaxInEur
        amount
        totals {
          id
          value
          valueInEuro
        }
        paymentMethod {
          id
          title
        }
        items {
          id
          amount
          totalPrice
          totalInEuro
          product {
            id
            sku
            masterSku
            title
            brand
            category
          }
        }
        billingAddress {
          id
          city
          regionCode
          countryCode
        }
      }
    }
  }
`;

export default OrderSuccessTrackingQuery;
